import mergeObj from '../extraUtil/mergeTwoObj';
import numeral from 'numeral';
let chart = {
    "yaxisname": "Avg. Bill Amount ($)",
    "xaxisname": "Customer",
    "palettecolors": "#6b7fd7",
    "plotfillalpha":"100"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    chart = mergeObj(chart, theme);
    let dataSource = {},
        customers = [],
        dataset = [],
        data = [],
        customerDataObj = {},
        customerCountObj = {};
        
    for (let i = 0; i < rawData.length; i++) {
        let customer = rawData[i]['customer'];
        if (!customers.includes(customer) && rawData[i]['billAmount']) {
            customers.push(customer);
            customerDataObj[customer] = 0 + parseFloat(rawData[i]['billAmount']);
            customerCountObj[customer] = 1;
        } else if (rawData[i]['billAmount']) {
            customerDataObj[customer] += parseFloat(rawData[i]['billAmount']);
            customerCountObj[customer]++;
        }
    }
    data = customers.map((customer) => {
        let value = customerDataObj[customer] / customerCountObj[customer];
        return {
            label: customer,
            value: value,
            tooltext: customer + ", " + numeral(value).format('$0,0.00')
        }
    })
    data = data.sort((a, b)=> {
       return (b.value - a.value);
    });
    dataset.push({
        "data": data
    });
    dataSource = {
        chart: chart,
        data: data
    }
    return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/avgBillForCutomer.js